// Credencial de sessao do navegador (leitura e limpeza), sem React e sem
// realtime. Extraida do AuthContext na FIELD-P3 para o REACTA FIELD usar a
// MESMA credencial sem importar o realtimeClient. Comportamento identico ao
// anterior; o transporte da credencial (armazenamento + header) continua o
// contrato atual — ver FIELD-P3-AUTENTICACAO-ACESSO-2026-10-25.md §4.

const IDENTITY_KEY = 'reacta_identity';

export function getStoredSessionId() {
  try {
    return localStorage.getItem('reacta_sessionId')
      || sessionStorage.getItem('reacta_sessionId')
      || localStorage.getItem('reacta_session_id')
      || sessionStorage.getItem('reacta_session_id');
  } catch {
    return null;
  }
}

// O conceito de "persistir identidade" no frontend foi abolido.
// A única verdade é o backend, acessado via sessionId.
// window.currentUser é um anti-padrão e foi removido.

// Função para limpar a sessão do frontend
export function clearIdentity() {
  try {
    // A única coisa que o frontend armazena é o ID da sessão.
    localStorage.removeItem('reacta_sessionId');
    sessionStorage.removeItem('reacta_sessionId');
    localStorage.removeItem('reacta_session_id');
    sessionStorage.removeItem('reacta_session_id');

    // Limpa chaves legadas para higiene.
    localStorage.removeItem(IDENTITY_KEY);
    localStorage.removeItem('reacta_operationId');
    localStorage.removeItem('reacta_userName');
    localStorage.removeItem('reacta_userRole');
    localStorage.removeItem('reacta_tenant');
    localStorage.removeItem('reacta_isPrivileged');
    localStorage.removeItem('orionToken');

    if (typeof window !== 'undefined') {
      // Garante que o objeto legado seja totalmente erradicado.
      try { delete window.currentUser; } catch { }
    }
  } catch (e) {
    console.error('[AuthContext] Falha ao limpar identidade', e);
  }
}
